module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADcSURBVEhL7ZJBDsFgEIUbiV0v4xo0UadwBRzBtUSwYu0MdmLHzzf9XyrVVvtLsOmXvLQz895ME6KOjt/jnFvfK6B/Qkte+7J+hl9Xjx2R9TO0pxYOXNFA9nC05y0c2PLoKdIuFApHplr/tQNHrQ9D+UY44BR5Qm+CDuiC9vhSjXJ8vB2KeKhTljo/8lgNY1kyNGqFIqXQDMUsnvuykVq/1pcOxOrFvmyk0s/BlfVzaNh/1wb2JfZFC9UbWQqE+i0wQq+/wQ0NZSkQ6s9gmKAdOuuZaFRJqL/jH0TRA47aINOzw0UMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-waggon-truck/light/24.png
// module id = 2536
// module chunks = 2